<template>
  <div class="uikit-form">
    <div class="uikit-modals">
      <m-table-settings
        v-model="modals.tableSettingsModal.active"
        :columns="modals.tableSettingsModal.columns"
        :disabled-columns="disabledColumns"
        :default-disabled-columns="defaultDisabledColumns"
        with-categories
      />

      <m-items
        :create-category="true"
        :active="modals.createCategoryPositionsModal.active"
        :groups="modals.createCategoryPositionsModal.groups"
        :current-group-item="modals.createCategoryPositionsModal.input"
        :required-message="''"
        :modal-title="'Создать категорию'"
        input-placeholder="Введите название категории"
        @close="closeCreateItemPositionsModal"
      />

      <m-items
        :modal-confirm="true"
        :active="modals.removeCategoryPositionsModal.active"
        :modal-title="'Удаление категории'"
        :modal-description="'Подтвердите удаление категории'"
        :modal-description-item="'Категорию'"
        @close="closeRemoveItemPositionsModal"
      />

      <c-sidesheet title="Боковое модальное окно (sidesheet)" :active="modals.sidesheet.active" @close="closeSidesheet">
        <div class="mt-3">Какой-то текст</div>
      </c-sidesheet>
    </div>

    <div class="layout__subtitle">Поля ввода</div>

    <div class="uikit-form__inputs">
      <b-row cols="12">
        <b-col class="mb-3" sm="12" md="6" lg="3">
          <div class="uikit-form__inputs-item">
            <c-input-2 v-model="inputs.simpleInput" placeholder="Текстовое поле без лейбла" type="text" />
          </div>
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="3">
          <div class="uikit-form__inputs-item">
            <c-input-2 type="textarea" textarea-max-height="250" placeholder="Поле с автоматическим изменение высоты" />
          </div>
        </b-col>
      </b-row>
    </div>

    <div class="layout__hr"></div>

    <div class="layout__subtitle">Поля ввода с плавающей меткой</div>

    <div class="uikit-form__inputs">
      <b-row cols="12">
        <b-col class="mt-2 mb-3" sm="12" md="6" lg="3">
          <div class="uikit-form__inputs-item">
            <c-input-old :clearable="true" floating-label="Поле с плавающей меткой" />
          </div>
        </b-col>
      </b-row>
    </div>

    <div class="layout__hr"></div>

    <div class="layout__subtitle">Textarea (новый)</div>

    <div class="uikit-form__inputs">
      <b-row cols="12">
        <b-col class="mt-2 mb-3" sm="12" md="6" lg="3">
          <div class="uikit-form__inputs-item">
            <c-textarea :clearable="true" label="Поле с обычной меткой" />
          </div>
        </b-col>
        <b-col class="mt-2 mb-3" sm="12" md="6" lg="3">
          <div class="uikit-form__inputs-item">
            <c-textarea :clearable="true" label="Поле с обычной меткой" :invalid="true" />
          </div>
        </b-col>
        <b-col class="mt-2 mb-3" sm="12" md="6" lg="3">
          <div class="uikit-form__inputs-item">
            <c-textarea :clearable="true" floating-label="Поле с плавающей меткой" />
          </div>
        </b-col>
        <b-col class="mt-2 mb-3" sm="12" md="6" lg="3">
          <div class="uikit-form__inputs-item">
            <c-textarea :clearable="true" floating-label="Поле с плавающей меткой" :invalid="true" />
          </div>
        </b-col>
      </b-row>
    </div>

    <div class="layout__hr"></div>

    <div class="layout__subtitle">Поле с возможностью копирования</div>

    <div>
      <copy-field
        text="Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quia voluptate suscipit, ut consectetur officia numquam."
        @copied="onCopy"
      ></copy-field>
    </div>

    <div class="layout__hr"></div>

    <div class="layout__subtitle">Выпадающие списки</div>

    <div class="uikit-form__selects">
      <b-row cols="12" class="uikit-form__row">
        <b-col class="mb-3" sm="12" md="6" lg="4">
          <div class="uikit-form__selects-item">
            <c-input-2
              v-model="selects.simpleSelectValue"
              label="Простой выпадающий список"
              type="select"
              :items="selects.items"
            />
          </div>
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="4">
          <div class="uikit-form__selects-item">
            <c-input-2
              v-model="selects.clearableSelectValue"
              label="С возможностью сброса"
              :items="selects.items"
              type="select"
              :clearable="true"
              placeholder="Все"
            />
          </div>
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="4">
          <div class="uikit-form__selects-item">
            <c-input-2
              v-model="selects.searchableSelectValue"
              label="С поиском"
              :items="selects.items"
              type="select"
              :searchable="true"
              :clearable="true"
              placeholder="Все"
            />
          </div>
        </b-col>
      </b-row>

      <b-row cols="12" class="uikit-form__row">
        <b-col class="mb-3" sm="12" md="6" lg="4">
          <div class="uikit-form__selects-item">
            <c-input-2
              v-model="selects.multipleSelectValue"
              label="С множественным выбором"
              type="select"
              :items="selects.items"
              :searchable="true"
              :multiple="true"
              placeholder="Все"
            />
          </div>
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="4">
          <div class="uikit-form__selects-item">
            <c-input-2
              v-model="selects.avatarSelectValue"
              label="С аватаром"
              :items="selectUsers"
              type="select"
              :searchable="true"
              :multiple="true"
              placeholder="Все"
            />
          </div>
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="4">
          <div class="uikit-form__selects-item">
            <c-input-2
              v-model="selects.multipleWithIconValue"
              :type="'select'"
              :label="'С опцией все кроме (чекбокс в виде иконки)'"
              :checkbox="true"
              :checkbox-type="'icon'"
              :checkbox-tooltip="{
                disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
                activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
                notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
              }"
              :disabled="selects.multipleWithIconValue.length === 0"
              :multiple="true"
              :searchable="true"
              :placeholder="'Все'"
              :items="selects.items"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="uikit-form__row">
        <b-col class="mb-3" sm="12" md="6" lg="4">
          <div class="uikit-form__selects-item">
            <c-input-2
              v-model="selects.withCategorized"
              type="select"
              label="Простой селект с группировкой"
              :with-categorized="true"
              :searchable="true"
              :placeholder="'Все'"
              :items="selects.itemsWithCategorized"
            />
          </div>
        </b-col>
        <b-col class="mb-3" sm="12" md="6" lg="4">
          <div class="uikit-form__selects-item">
            <c-select
              v-model="selects.multipleWithGroup"
              type="select"
              label="С опцией все кроме и групповыми значениями"
              :reverse-type="'icon'"
              :reverse-tooltip="{
                disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
                activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
                notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
              }"
              :multiple="true"
              :searchable="true"
              :placeholder="'Все'"
              :items="selects.items"
              :groups="selects.groups"
            />
          </div>
        </b-col>
        <b-col class="mb-3" sm="12" md="6" lg="4">
          <div class="uikit-form__selects-item">
            <c-select
              class="m-write-fine-form-item-row-basis"
              type="select"
              label="С одним выбором и групповыми значениями"
              :searchable="true"
              :items="selects.items"
              :groups="selects.groups"
              placeholder="Выберите значение"
            />
          </div>
        </b-col>
      </b-row>
    </div>

    <div class="layout__hr"></div>

    <div class="layout__subtitle">Выбор даты</div>

    <div class="uikit-form__datepickers">
      <b-row cols="12">
        <b-col class="mb-3" sm="12" md="6" lg="3">
          <c-input-2
            v-model="datepickers.simpleValue"
            label="С не редактируемым полем"
            type="date"
            format="DD.MM.YYYY, dddd"
            icon="calendar"
            placeholder="Выберите дату"
            :icon-right="true"
            :clearable="true"
          />
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="3">
          <c-input-2
            v-model="datepickers.editableValue"
            label="Период"
            placeholder="Выберите период"
            type="period"
            icon="calendar"
            :icon-right="true"
          />
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="3">
          <c-input-2
            v-model="datepickers.editableValue"
            label="Период без фикс. значений"
            placeholder="Выберите период"
            type="period-without-fixed-intervals"
            icon="calendar"
            :icon-right="true"
          />
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="3">
          <c-input-2
            v-model="datepickers.periodValue"
            label="С редактируемым полем"
            placeholder="Все"
            type="date"
            icon="calendar"
            :icon-right="true"
            :editable="true"
          />
        </b-col>
      </b-row>

      <b-row cols="12">
        <b-col class="mb-3" sm="12" md="6" lg="3">
          <week-days v-model="weekDays"></week-days>
        </b-col>
        <b-col class="mb-3" sm="12" md="6" lg="3">
          <month-days v-model="monthDays"></month-days>
        </b-col>
        <b-col class="mb-3" sm="12" md="6" lg="3">
          <date-select v-model="yearDays"></date-select>
        </b-col>
        <b-col class="mb-3" sm="12" md="6" lg="3">
          <date-select v-model="randomDays" :with-year="true"></date-select>
        </b-col>
      </b-row>

      <b-row cols="12">
        <b-col class="mb-3" sm="12" md="6" lg="3">
          <month-select v-model="month" label="Период"></month-select>
        </b-col>
      </b-row>
    </div>

    <!-- <div class="layout__hr"></div>

    <div class="layout__subtitle">Выбор даты (новый)</div>

    <div class="uikit-form__datepickers">
      <b-row cols="12">
        <b-col class="mb-3" sm="12" md="6" lg="3">
          <c-date-picker
            label="С не редактируемым полем"
            type="date"
            format="DD.MM.YYYY, dddd"
            placeholder="Выберите дату"
            :clearable="true"
            v-model="datepickers.simpleValue"
          />
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="3">
          <c-date-picker
            label="Период"
            placeholder="Выберите период"
            :ranges="true"
            type="period"
            v-model="datepickers.editableValue"
          />
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="3">
          <c-date-picker
            label="Период без интервалов"
            placeholder="Выберите период"
            type="period"
            v-model="datepickers.editableValue"
          />
        </b-col>

        <b-col class="mb-3" sm="12" md="6" lg="3">
          <c-date-picker
            label="С редактируемым полем"
            placeholder="Все"
            type="date"
            v-model="datepickers.periodValue"
            :editable="true"
          />
        </b-col>
      </b-row>
    </div> -->

    <div class="layout__hr"></div>

    <div class="layout__subtitle">Выбор цвета</div>

    <div class="uikit-form__color">
      <color-select v-model="color" label="Выберите цвет" :validate="true"></color-select>
    </div>

    <div class="layout__hr"></div>

    <div class="layout__subtitle">Переключатели</div>

    <div class="uikit-form__switchers">
      <div class="uikit-form__switchers-item">
        <c-switcher label="Переключатель" />
      </div>

      <div class="uikit-form__switchers-item">
        <c-switcher type="checkbox" label="Чекбокс" />
      </div>

      <div class="uikit-form__switchers-item">
        <c-switcher type="checkbox" label="Неактивный чекбокс" :disabled="true" />
      </div>

      <div class="uikit-form__switchers-item">
        <c-switcher
          type="checkbox-icon"
          :tooltip="{
            disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
            activeText: 'Включен фильтр по всем значениям в справочнике, кроме выбранных',
            notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
          }"
        />
      </div>

      <div class="uikit-form__switchers-item">
        <c-switcher-2
          type="group"
          :items="[
            { icon: 'ruble', value: 'ruble' },
            { icon: 'percent', value: 'percent' },
          ]"
        />
      </div>

      <div class="uikit-form__switchers-item">
        <c-switcher-2
          type="group"
          :items="[
            { label: 'Число', value: 'number' },
            { label: 'Диапазон', value: 'range' },
          ]"
        />
      </div>

      <div class="uikit-form__switchers-item">
        <c-switcher-2
          type="group"
          class="h-switcher"
          :items="[
            { label: 'Число', value: 'number' },
            { label: 'Диапазон', value: 'range' },
          ]"
        />
      </div>

      <b-row cols="12">
        <b-col class="mb-3" sm="12" md="6" lg="3">
          <user-select
            v-model="selects.selectedUsers"
            :users="[
              {
                name: 'Мария Иванова',
                avatar: '',
              },
              {
                name: 'Александр Петров',
                avatar: '',
              },
              {
                name: 'Василий Васильевич',
                avatar: '',
              },
              {
                name: 'Вася Пупкин',
                avatar: '',
              },
            ]"
            :multiple="true"
          />
        </b-col>
      </b-row>
    </div>

    <div class="layout__hr"></div>

    <div class="layout__subtitle"></div>

    <div class="layout__hr"></div>

    <div class="layout__subtitle">Модальные окна</div>

    <div class="uikit-form__modals">
      <div class="uikit-form__row">
        <c-button
          responsive
          label="Настроить столбцы"
          icon="cog"
          type="with-icon"
          @click="modals.tableSettingsModal.active = true"
        />
        <c-button
          class="ml-3"
          responsive
          label="Создать категорию (должности)"
          icon="plus"
          type="with-icon"
          @click="modals.createCategoryPositionsModal.active = true"
        />
        <c-button
          class="ml-3"
          responsive
          label="Удалить категорию (должности)"
          icon="trash"
          type="with-icon"
          @click="modals.removeCategoryPositionsModal.active = true"
        />
      </div>
      <div class="uikit-form__row">
        <c-button-2 label="Боковое модальное окно" size="small" @click="modals.sidesheet.active = true" />
      </div>
    </div>

    <div class="layout__hr"></div>

    <div class="layout__subtitle">Блоки с информацией</div>

    <div class="uikit-form__info-block">
      <div class="uikit-form__info-block-item">
        Выплачено производству:
        <span>157 951 450 ฿</span>
      </div>

      <div class="uikit-form__info-block-item">
        Выплачено доставке:
        <span>69 901 550 ฿</span>
      </div>
    </div>

    <div class="layout__hr"></div>

    <div class="layout__subtitle">Таблица с фиксированной шапкой</div>

    <div class="uikit-form__table-wrapper">
      <c-data-table
        ref="table"
        :levels="2"
        :disabled-columns="disabledColumns"
        :enabled-fields="tableData.enabledFields"
        :sorted-column="tableData.sortedColumn"
        :data="tableData"
        :filtered-columns="tableData.filteredColumns"
        :active-filtered-columns="tableData.activeFilteredColumns"
        :reference-list="tableData.referenceList"
        @reset-column-filters="tableData.activeFilteredColumns = []"
        @remove-column-filter="onColumnFilterRemove"
        @set-column-filter="onSetColumnFilter"
        @set-column-filter-by-index="onSetColumnFilterByIndex"
        @disable-column-sorted-flag="onDisableColumnSortedFlag"
        @change-sorting-column="onSortingColumnChange"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Button from "@/components/controls/button";
import Button2 from "@/components/controls2/Button";
import Textarea from "@/components/textarea";
import Input2 from "@/components/controls2/Input";
import InputOld from "@/components/controls/input-old";
import Select from "@/components/controls2/Select";
import Switcher from "@/components/controls/switcher";
import Switcher2 from "@/components/controls2/Switcher";
import TableSettingsModal from "@/components/modals/table-settings";
import DataTable from "@/components/data-table";
import ModalPositionsItems from "@/pages/positions/items-modal";
import Sidesheet from "@/components/sidesheet";
import CopyField from "@/components/copy-field";
import ColorSelect from "@/components/controls/color-select";
import WeekDays from "@/components/week-days";
import MonthDays from "@/components/month-days";
import DateSelect from "@/components/date-select";
import MonthSelect from "@/components/month-select";
import UserSelect from "@/components/user-select";

export default {
  name: "uikit-form",

  components: {
    "c-textarea": Textarea,
    "c-button": Button,
    "c-button-2": Button2,
    "c-input-2": Input2,
    "c-input-old": InputOld,
    "c-select": Select,
    "c-switcher": Switcher,
    "c-switcher-2": Switcher2,
    "c-data-table": DataTable,
    "c-sidesheet": Sidesheet,
    "m-table-settings": TableSettingsModal,
    "m-items": ModalPositionsItems,
    CopyField,
    ColorSelect,
    WeekDays,
    MonthDays,
    DateSelect,
    MonthSelect,
    UserSelect,
  },

  data() {
    return {
      inputs: {
        simpleInput: "",
        clearableInput: "",
        searchInput: "",
        maskedInput: "",
      },

      selects: {
        selectedUsers: ["Александр Петров"],
        groups: [
          { name: "category-1", label: "Первая категория" },
          { name: "category-2", label: "Вторая категория" },
          { name: "category-3", label: "Третья категория" },
        ],

        items: [
          { label: "Первый элемент", value: 1, group: "category-1", subLabel: "Доп. подпись" },
          { label: "Второй элемент", value: 2, group: "category-1" },
          { label: "Третий элемент", value: 3, group: "category-1", subLabel: "Доп. подпись" },
          { label: "Четвертый элемент", value: 4, group: "category-2" },
          { label: "Пятый элемент", value: 5, group: "category-2" },
          { label: "Шестой элемент", value: 6, group: "category-3" },
          { label: "Седьмой элемент", value: 7, group: "category-3" },
          { label: "Восмой элемент", value: 8, group: "category-3" },
        ],

        itemsWithCategorized: [
          {
            label: "Водитель",
            value: 1,
            isSubCategory: false,
            formatLabel: "<b>Водитель</b>",
          },
          {
            label: "Костюм",
            value: 2,
            isSubCategory: true,
            formatLabel: "<b>Водитель</b>/Костюм",
          },
          {
            label: "Пропускной талон",
            value: 3,
            isSubCategory: true,
            formatLabel: "<b>Водитель</b>/Пропускной талон",
          },
          {
            label: "Повар",
            value: 4,
            isSubCategory: false,
            formatLabel: "<b>Повар</b>",
          },
          {
            label: "Поварской китель",
            value: 5,
            isSubCategory: true,
            formatLabel: "<b>Повар</b>/Поварской китель",
          },
          {
            label: "Брюки поварские",
            value: 6,
            isSubCategory: true,
            formatLabel: "<b>Повар</b>/Брюки поварские",
          },
          {
            label: "Администратор",
            value: 7,
            isSubCategory: false,
            formatLabel: "<b>Администратор</b>",
          },
          {
            label: "Блузка администратора",
            value: 8,
            isSubCategory: true,
            formatLabel: "<b>Администратор</b>/Блузка администратора",
          },
        ],

        withCategorized: null,

        simpleSelectValue: {
          label: "Первый элемент",
          value: 1,
          group: "category-1",
        },

        clearableSelectValue: null,

        searchableSelectValue: null,

        multipleSelectValue: [],

        requiredSelectValue: [],

        reverseSelectValue: [],
        reverseValue: false,

        avatarSelectValue: [],

        multipleWithIconValue: [],

        multipleWithGroup: [],
      },

      datepickers: {
        simpleValue: "",
        editableValue: "",
        periodValue: "",
      },

      color: "",

      modals: {
        tableSettingsModal: {
          active: false,
        },

        createCategoryPositionsModal: {
          active: false,
          input: "Любое значение",
          groups: [
            { code: 1, label: "Производство", value: "1" },
            { code: 2, label: "Доставка", value: "2" },
            { code: 3, label: "Менеджмент", value: "3" },
          ],
        },

        removeCategoryPositionsModal: {
          active: false,
        },

        sidesheet: {
          active: false,
        },
      },
      defaultDisabledColumns: [],
      disabledColumns: [],

      weekDays: [],
      monthDays: [],
      yearDays: [],
      randomDays: [],
      month: moment().format("YYYY-MM-DD"),
    };
  },

  computed: {
    ...mapGetters("test", ["getTableData"]),

    tableData() {
      let records = [];

      for (let i = 1; i < 10; i++) {
        records = records.concat(this.getTableData.records);
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.modals.tableSettingsModal.columns = this.getTableData.columns;

      return {
        columns: this.getTableData.columns,
        records,
        enabledFields: [],
        levels: this.getTableData.levels,
        actions: this.getTableData.columns,
        type: this.getTableData.type,
        filteredColumns: ["filial", "fullName", "deposit", "columnDate"],
        activeFilteredColumns: [],
        referenceList: [
          { id: 1, label: "Щербинка" },
          { id: 2, label: "Бутово" },
          { id: 3, label: "Ясенево" },
          { id: 4, label: "Коммунарка" },
          { id: 5, label: "Подольск" },
        ],
      };
    },

    users() {
      return this.$store.getters.users;
    },

    selectUsers() {
      return this.users.map((item) => ({
        label: item.name,
        value: item.id,
        avatar: item.avatar,
      }));
    },
  },

  watch: {
    "datepickers.simpleValue": function (value) {
      console.log("value: ", value);
    },
  },

  methods: {
    onCopy() {
      console.log("copied");
    },
    closeRemoveItemPositionsModal() {
      this.modals.removeCategoryPositionsModal.active = false;
    },

    closeCreateItemPositionsModal() {
      this.modals.createCategoryPositionsModal.active = false;
    },

    closeSidesheet() {
      this.$emit("close");
      setTimeout(() => {
        this.modals.sidesheet.active = false;
      }, 150);
    },
    onColumnFilterRemove(columnIndex) {
      this.tableData.activeFilteredColumns.splice(columnIndex, 1);
    },
    onSetColumnFilter(filterOptions) {
      this.tableData.activeFilteredColumns.push(filterOptions);
    },
    onSetColumnFilterByIndex(columnIndex, filterOptions) {
      this.tableData.activeFilteredColumns[columnIndex] = filterOptions;
    },
    onDisableColumnSortedFlag(columnIndex) {
      this.tableData.columns[columnIndex].isSorted = false;
    },
    onSortingColumnChange(sortingData) {
      this.tableData.sortedColumn = sortingData;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.uikit-form {
  &__row {
    & + .uikit-form__row {
      margin-top: 20px;
    }
  }

  &__switchers {
    display: flex;
    align-items: center;

    &-item {
      margin-left: 30px;
      display: flex;
      align-items: center;

      &:first-child {
        margin-left: 0;
      }
    }
  }

  &__info-block {
    display: flex;
    background: $color-bg;
    height: 30px;
    border-radius: 15px;
    padding: 0 20px;
    align-items: center;

    @media (max-width: 1419px) {
      justify-content: center;
      margin-bottom: 20px;
    }

    @media screen and (max-width: 992px) {
      margin-bottom: 0;
    }

    @media (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
      height: auto;
      margin: 0 -30px;
      margin-top: -20px !important;
      padding: 7px 20px;
      border-radius: 0;
    }

    @media screen and (max-width: 700px) {
      margin: 0 -20px;
    }

    &-item {
      font-size: 13px;
      color: $color-label;
      margin-left: 14px;

      &:first-child {
        margin-left: 0;
      }

      @media (max-width: 767px) {
        margin-left: 0;
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      span {
        color: black;
        font-weight: 500;
      }
    }
  }

  &__table-wrapper {
    position: relative;
  }
}
</style>
